import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { Image } from '../components/atoms';
import { LearnMoreLink } from '../components/atoms';
import { SectionHeader } from '../components/molecules';
import { HeroShaped } from '../components/organisms';
import {CompanyData} from "../content";
import {images} from "../components/MediaLib";

const useStyles = makeStyles(theme => ({
  root: {
    '& .hero-shaped': {
      borderBottom: 0,
    },
    '& .hero-shaped__wrapper': {
      [theme.breakpoints.up('md')]: {
        minHeight: `calc(100vh - ${theme.mixins.toolbar['@media (min-width:600px)'].minHeight}px)`,
      },
    },
  },
  formContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
      margin: `0 auto`,
    },
  },
  image: {
    objectFit: 'cover',
  },
  label: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
}));

export const NotFoundCover = ({label, subtitle, action_intro, action_label, back_label, ...props}) => {
  const classes = useStyles();

  const handleClick = () => {
    window.history.back();
  };

  return (
    <div className={classes.root}>
      <HeroShaped
        leftSide={
          <div className={classes.formContainer}>
            <SectionHeader
              label={label || "404"}
              title={subtitle}
              subtitle={
                <span>
                  {action_intro}{' '}
                  <LearnMoreLink
                    title={action_label}
                    href={"mailto:"+CompanyData.support_email}
                    typographyProps={{ variant: 'h6' }}
                  />
                </span>
              }
              titleProps={{
                variant: 'h3',
              }}
              labelProps={{
                color: 'secondary',
                className: classes.label,
                variant: 'h5',
              }}
              ctaGroup={[
                <Button
                  size="large"
                  variant="contained"
                  color="primary"
                  onClick={handleClick}
                >
                  {back_label}
                </Button>,
              ]}
              disableGutter
            />
          </div>
        }
        rightSide={
          <Image
            src={images.cables}
            className={classes.image}
            lazy={false}
          />
        }
      />
    </div>
  );
};

NotFoundCover.propTypes = {
  label: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  action_intro: PropTypes.string.isRequired,
  action_label: PropTypes.string.isRequired,
  back_label: PropTypes.string.isRequired,
};